var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('checkbox-filter',{attrs:{"identifier":"transferFilter","initial-value":false,"label":_vm.transferLabel,"isAccordionOpen":_vm.isAccordionOpen}}),_c('checkbox-filter',{attrs:{"identifier":"trainToFlightFilter","initial-value":false,"label":_vm.trainToFlightLabel,"isAccordionOpen":_vm.isAccordionOpen}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }